var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarCheck4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2803 11.1053C15.5732 10.8124 15.5732 10.3376 15.2803 10.0447C14.9874 9.75178 14.5126 9.75178 14.2197 10.0447L10.9 13.3643L9.78033 12.2447C9.48744 11.9518 9.01256 11.9518 8.71967 12.2447C8.42678 12.5376 8.42678 13.0124 8.71967 13.3053L10.3697 14.9553C10.5103 15.096 10.7011 15.175 10.9 15.175C11.0989 15.175 11.2897 15.096 11.4303 14.9553L15.2803 11.1053Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 2.75C8.5 2.33579 8.16421 2 7.75 2C7.33579 2 7 2.33579 7 2.75V4H6.75C4.67894 4 3 5.67894 3 7.75V17.25C3 19.3211 4.67894 21 6.75 21H17.25C19.3211 21 21 19.3211 21 17.25V7.75C21 5.67894 19.3211 4 17.25 4H17V2.75C17 2.33579 16.6642 2 16.25 2C15.8358 2 15.5 2.33579 15.5 2.75V4H8.5V2.75ZM4.5 7.75C4.5 6.50736 5.50736 5.5 6.75 5.5H17.25C18.4927 5.5 19.5 6.50736 19.5 7.75V17.25C19.5 18.4927 18.4927 19.5 17.25 19.5H6.75C5.50736 19.5 4.5 18.4927 4.5 17.25V7.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCheck4);
export default __webpack_public_path__ + "static/media/calendar-check-4.1dacb0d7a50a394f1d252054c41aa45e.svg";
export { ForwardRef as ReactComponent };